import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FormProvider, useForm } from "react-hook-form";
import StickyToolbar from "../../../../StickyToolbar";
import Select from "react-select";
import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import {
    ListarEmpreendimentosController,
    ListarProdutosPorEmpreendimentosController,
} from "../../../../../Controllers/Geral/Produtos/ProdutosControllers";
import { ListarUsuariosController } from "../../../../../Controllers/Geral/GestaoUsuarios/UsuariosController";
import { IGestaoLogsControleReparoFiltro } from "../../../../../Interfaces/Geral/GestaoLogsControleReparo/GestaoLogsControleReparoInterface";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import { ListarEtapasPorCategoriaAtendimentoOuTipoCasoController } from "../../../../../Controllers/Geral/Etapas/EtapasControllers";
import UnForm from "../../../../Form";

interface IFiltroGestaoLogsControleReparo {
    FILTRO_GESTAO_LOGS_CONTROLE_REPARO: string | null;
    filter: IGestaoLogsControleReparoFiltro;
    filtroInicial: IGestaoLogsControleReparoFiltro;
    handleDateChange: (formData: IGestaoLogsControleReparoFiltro) => void;
    setFilter: (filter: IGestaoLogsControleReparoFiltro) => void;
    setPage: (page: number) => void;
    setIdEmpreendimento: Dispatch<SetStateAction<number[]>>;
    setIdProduto: Dispatch<SetStateAction<number[]>>;
    setIdUsuario: Dispatch<SetStateAction<number>>;
    setIdEtapa: Dispatch<SetStateAction<number>>;
}

interface Option {
    label: string;
    value: number;
}

const customStyles = {
    control: (base: any) => ({
        ...base,
        boxShadow: "none",
        border: "1px solid #e4e6ef",
        transition:
            "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
    }),
};

export default function FiltroGestaoLogsControleReparo(
    props: IFiltroGestaoLogsControleReparo
) {
    const FormMethods = useForm();
    const { reset, setValue } = FormMethods;

    const selectInputRef = useRef<any>();
    const selectProdutoRef = useRef<any>();
    const selectEtapaRef = useRef<any>();
    const selectEmpRef = useRef<any>();
    const [optionsEmpreendimentos, setOptionsEmpreendimentos] = useState<
        Option[]
    >([]);
    const [valueEmpreendimentos, setValueEmpreendimentos] = useState<Option[]>(
        []
    );
    const [valueProdutos, setValueProdutos] = useState<Option[]>([]);
    const [optionsEtapas, setOptionsEtapas] = useState<Option[]>([]);
    const { value: listarEmpreendimentos } = useAsyncEffect(
        () => ListarEmpreendimentosController(),
        []
    );
    const { value: lstEtapas } = useAsyncEffect(
        () => ListarEtapasPorCategoriaAtendimentoOuTipoCasoController(1), // 1 = Assistência Técnica
        []
    );
    useEffect(() => {
        if (listarEmpreendimentos) {
            setOptionsEmpreendimentos(
                listarEmpreendimentos.map((empreendimento) => ({
                    label: empreendimento.DS_EMPREENDIMENTO,
                    value: empreendimento.ID_EMPREENDIMENTO,
                }))
            );
        }
    }, [listarEmpreendimentos]);

    useEffect(() => {
        if (lstEtapas) {
            setOptionsEtapas(
                lstEtapas.map((etapa) => ({
                    label: etapa.DS_ETAPA,
                    value: etapa.ID_ETAPA_TIPO_CASO,
                }))
            );
        }
    }, [lstEtapas]);

    const { value: listarUsuarios } = useAsyncEffect(
        () => ListarUsuariosController(),
        []
    );

    const { execute: listarUnidades, value: unidadesListadas } =
        useAsyncCallback(ListarProdutosPorEmpreendimentosController);

    const lstUnidadesOptions = unidadesListadas?.map((e) => ({
        label: e.DS_PRODUTO,
        value: e.ID_PRODUTO,
    }));

    const lstUsuariosOptions = listarUsuarios?.map((u) => ({
        label: u.DS_NOME,
        value: u.ID_USUARIO,
    }));

    const limparFiltros = () => {
        selectInputRef.current?.clearValue();
        selectProdutoRef.current?.clearValue();
        selectEtapaRef.current?.clearValue();
        selectEmpRef.current?.clearValue();
        props.setIdEmpreendimento([]);
        props.setIdProduto([]);
        props.setIdUsuario(0);
        props.setIdEtapa(0);
    };

    return (
        <>
            <StickyToolbar active={!!props.FILTRO_GESTAO_LOGS_CONTROLE_REPARO}>
                <FormProvider {...FormMethods}>
                    <UnForm
                        usingContext
                        handleSubmit={(formData) =>
                            props.handleDateChange(formData)
                        }
                        className="form-group row"
                    >
                        <div className="col-12 mt-3">
                            <label>Protocolo</label>
                            <UnForm.Input
                                className="form-control"
                                type="number"
                                name="ID_CASO"
                                defaultValue={props.filter?.ID_CASO}
                                registerOptions={{
                                    valueAsNumber: true,
                                }}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Cliente</label>
                            <UnForm.Input
                                className="form-control"
                                type="text"
                                defaultValue={props.filter?.DS_CLIENTE}
                                name="DS_CLIENTE"
                                registerOptions={{}}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>CPF</label>
                            <UnForm.Input
                                className="form-control"
                                type="text"
                                defaultValue={props.filter?.NR_CPF}
                                name="NR_CPF"
                                registerOptions={{}}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Usuário</label>
                            <Select
                                name="ID_USUARIO"
                                ref={selectInputRef}
                                options={lstUsuariosOptions}
                                isClearable
                                components={{
                                    DropdownIndicator: () => null,
                                    IndicatorSeparator: () => null,
                                }}
                                styles={customStyles}
                                placeholder={""}
                                noOptionsMessage={() => "Sem opções"}
                                onChange={(selectedOption) => {
                                    if (selectedOption) {
                                        setValue(
                                            "ID_USUARIO",
                                            selectedOption.value
                                        );
                                        props.setIdUsuario(
                                            selectedOption.value
                                        );
                                    } else {
                                        setValue("ID_USUARIO", null);
                                    }
                                }}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Data Inicial</label>
                            <UnForm.Input
                                className="form-control"
                                type="date"
                                defaultValue={props.filter?.DT_INICIO}
                                name="DT_INICIO"
                                registerOptions={{}}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Data Final</label>
                            <UnForm.Input
                                className="form-control"
                                type="date"
                                defaultValue={props.filter?.DT_FIM}
                                name="DT_FIM"
                                registerOptions={{}}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Empreendimento</label>
                            <Select
                                name="ID_EMPREENDIMENTO"
                                ref={selectEmpRef}
                                options={optionsEmpreendimentos}
                                value={valueEmpreendimentos}
                                isClearable
                                isMulti
                                onChange={(selectedOptions) => {
                                    const selectedValues = selectedOptions.map(
                                        (option) => ({
                                            value: option.value,
                                            label: option.label,
                                        })
                                    );
                                    props.setIdEmpreendimento(
                                        selectedValues.map(
                                            (option) => option.value
                                        )
                                    );
                                    setValueEmpreendimentos(selectedValues);
                                    const ids = selectedValues.map(
                                        (v) => v.value
                                    );
                                    listarUnidades({
                                        ID_EMPREENDIMENTO: ids,
                                    });
                                }}
                                components={{
                                    DropdownIndicator: () => null,
                                    IndicatorSeparator: () => null,
                                }}
                                styles={customStyles}
                                placeholder={""}
                                noOptionsMessage={() => "Sem opções"}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Unidade</label>
                            <Select
                                name="ID_PRODUTO"
                                ref={selectProdutoRef}
                                options={lstUnidadesOptions}
                                value={valueProdutos}
                                isClearable
                                isMulti
                                onChange={(selectedOptions) => {
                                    if (selectedOptions) {
                                        const selectedValues =
                                            selectedOptions.map(
                                                (option: Option) => ({
                                                    value: option.value,
                                                    label: option.label,
                                                })
                                            );
                                        props.setIdProduto(
                                            selectedValues.map(
                                                (option) => option.value
                                            )
                                        );
                                        setValueProdutos(selectedValues);
                                    }
                                }}
                                components={{
                                    DropdownIndicator: () => null,
                                    IndicatorSeparator: () => null,
                                }}
                                styles={customStyles}
                                placeholder={""}
                                noOptionsMessage={() => "Sem opções"}
                            />
                        </div>

                        <div className="col-12 mt-3">
                            <label>Etapa</label>
                            <Select
                                name="ID_ETAPA_TIPO_CASO"
                                ref={selectEtapaRef}
                                options={optionsEtapas}
                                isClearable
                                components={{
                                    DropdownIndicator: () => null,
                                    IndicatorSeparator: () => null,
                                }}
                                styles={customStyles}
                                placeholder={""}
                                noOptionsMessage={() => "Sem opções"}
                                onChange={(selectedOption) => {
                                    if (selectedOption) {
                                        setValue(
                                            "ID_ETAPA_TIPO_CASO",
                                            selectedOption.value
                                        );
                                        props.setIdEtapa(selectedOption.value);
                                    } else {
                                        setValue("ID_ETAPA_TIPO_CASO", null);
                                    }
                                }}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Descrição da Ação</label>
                            <UnForm.Select
                                name="DS_ACAO"
                                className="form-control"
                                registerOptions={{}}
                                defaultValue={props.filter?.DS_ACAO}
                            >
                                <option value={""}></option>
                                <option value={"INSERÇÃO"}>Inserção</option>
                                <option value={"EDIÇÃO"}>Edição</option>
                                <option value={"EXCLUSÃO"}>Exclusão</option>
                            </UnForm.Select>
                        </div>
                        <div className="col-12 d-flex align-items-end justify-content-start">
                            <button
                                type="submit"
                                className="btn btn-block btn-outline-dark mt-2"
                            >
                                <FontAwesomeIcon
                                    icon={faFilter}
                                    className="mr-2"
                                />
                                Filtrar
                            </button>
                        </div>
                        <div className="col-12 d-flex align-items-end justify-content-start">
                            <button
                                type="button"
                                onClick={() => {
                                    window.sessionStorage.removeItem(
                                        "FILTRO_GESTAO_LOGS_CONTROLE_REPARO"
                                    );
                                    props.setFilter(props.filtroInicial);
                                    reset(props.filtroInicial);
                                    limparFiltros();
                                }}
                                className="btn btn-block btn-outline-danger mt-2"
                            >
                                <FontAwesomeIcon
                                    icon={faTimes}
                                    className="mr-2"
                                />
                                Limpar Filtros
                            </button>
                        </div>
                    </UnForm>
                </FormProvider>
            </StickyToolbar>
        </>
    );
}
